import { render, staticRenderFns } from "./AnncmntModal.vue?vue&type=template&id=af16fac2&scoped=true"
import script from "./AnncmntModal.vue?vue&type=script&lang=js"
export * from "./AnncmntModal.vue?vue&type=script&lang=js"
import style0 from "./AnncmntModal.vue?vue&type=style&index=0&id=af16fac2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af16fac2",
  null
  
)

export default component.exports